"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var config_1 = __importDefault(require("config"));
var routes_1 = __importDefault(require("./routes"));
var react_query_1 = require("react-query");
var devtools_1 = require("react-query/devtools");
var material_1 = require("@mui/material");
var services_1 = require("./services");
var react_toastify_1 = require("react-toastify");
var context_1 = require("./context");
require("react-toastify/dist/ReactToastify.css");
var react_error_boundary_1 = require("react-error-boundary");
var components_1 = require("./components");
function App() {
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, __assign({ client: services_1.queryClient }, { children: (0, jsx_runtime_1.jsx)(context_1.GlobalLoadingProvider, { children: (0, jsx_runtime_1.jsx)(context_1.AuthProvider, { children: (0, jsx_runtime_1.jsxs)(context_1.InactivityLogoutProvider, { children: [(0, jsx_runtime_1.jsx)(context_1.MerchantConfigProvider, { children: (0, jsx_runtime_1.jsxs)(context_1.ThemeMdProvider, { children: [(0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), (0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { theme: "colored" }), (0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, __assign({ FallbackComponent: components_1.ErrorBoundaryComponent }, { children: (0, jsx_runtime_1.jsx)(routes_1.default, {}) }))] }) }), config_1.default.env === 'development' && ((0, jsx_runtime_1.jsx)(devtools_1.ReactQueryDevtools, { position: "bottom-left" }))] }) }) }) })));
}
exports.default = App;
